module.exports = __webpack_public_path__ + "assets/basic-close-726b1e.svg";